import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const ContactUs = ( props ) => {
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
    },[]);
    const { t, i18n } = useTranslation();

    return (
        <Container style={{ marginTop: '70px' }}>
            <Row>
                <Col xs="12">
                    <h4 style={{textAlign: 'center'}}>
                        {t('contactUsText')}<a href="mailto:ipsp@hp.com?">ipsp@hp.com</a>
                    </h4>
                </Col>
            </Row>
        </Container>
    );
}

export default ContactUs;